import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.023 24.646c-.253 0-.638-.192-.942-.385-5.664-3.648-9.292-7.924-9.292-12.26 0-3.72 2.574-6.313 5.806-6.313 2.006 0 3.526 1.124 4.428 2.786z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.977 24.646c.253 0 .638-.192.942-.385 5.664-3.648 9.292-7.924 9.292-12.26 0-3.72-2.574-6.313-5.806-6.313-2.007 0-3.526 1.124-4.428 2.786z"
    }, null, -1)
  ])))
}
export default { render: render }